<!-- =========================================================================================
    File Name: Main.vue
    Description: Main layout
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div v-if="!isMobile" class="layout--main no-scroll" :class="[{ 'no-scroll': isAppPage }]">
		<v-nav-menu :navMenuItems="navMenuItems" title="Agri Index" parent=".layout--main" v-if="$store.state.windowWidth <= 600" />

		<div id="content-area">
			<div id="content-overlay" />

			<!-- Navbar -->
      <template v-if="mainLayoutType === 'horizontal' && windowWidth >= 1200">
				<the-navbar-horizontal :navbarType="navbarType" :class="[{ 'text-white': isNavbarDark && !isThemeDark }, { 'text-base': !isNavbarDark && isThemeDark }]" />

				<div style="height: 62px" v-if="navbarType === 'static'"></div>

				<h-nav-menu :class="[{ 'text-white': isNavbarDark && !isThemeDark }, { 'text-base': !isNavbarDark && isThemeDark }]" :navMenuItems="navMenuItems" />
			</template>

			<template v-else>
				<the-navbar-vertical-custom :navbarColor="navbarColor" :class="[{ 'text-white': isNavbarDark && !isThemeDark }, { 'text-base': !isNavbarDark && isThemeDark }]" />
			</template>
			<!-- /Navbar -->

			<div class="content-wrapper">
				<div class="router-view">
					<div class="router-content">
					<transition :name="routerTransition">
							<div v-if="$route.meta.breadcrumb || $route.meta.pageTitle" class="router-header flex flex-wrap items-center mb-6">
								<div class="content-area__heading" :class="{ 'pr-4 border-0 md:border-r border-solid border-grey-light': $route.meta.breadcrumb }">
									<h2 class="mb-1">{{ routeTitle }}</h2>
								</div>

								<!-- BREADCRUMB -->
								<vx-breadcrumb class="ml-4 md:block hidden" v-if="$route.meta.breadcrumb" :route="$route" :isRTL="$vs.rtl" />

								<!-- DROPDOWN -->
								<!--<vs-dropdown vs-trigger-click class="ml-auto md:block hidden cursor-pointer">
									<vs-button radius icon="icon-settings" icon-pack="feather" />

									<vs-dropdown-menu class="w-32">
										<vs-dropdown-item>
											<div @click="$router.push('/pages/profile').catch(() => {})" class="flex items-center">
												<feather-icon icon="UserIcon" class="inline-block mr-2" svgClasses="w-4 h-4" />
												<span>Profile</span>
											</div>
										</vs-dropdown-item>
										<vs-dropdown-item>
											<div @click="$router.push('/apps/todo').catch(() => {})" class="flex items-center">
												<feather-icon icon="CheckSquareIcon" class="inline-block mr-2" svgClasses="w-4 h-4" />
												<span>Tasks</span>
											</div>
										</vs-dropdown-item>
										<vs-dropdown-item>
											<div @click="$router.push('/apps/email').catch(() => {})" class="flex items-center">
												<feather-icon icon="MailIcon" class="inline-block mr-2" svgClasses="w-4 h-4" />
												<span>Inbox</span>
											</div>
										</vs-dropdown-item>
									</vs-dropdown-menu>
								</vs-dropdown>-->
							</div>
						</transition>

						<div class="content-area__content">
							<back-to-top bottom="5%" :right="$vs.rtl ? 'calc(100% - 2.2rem - 38px)' : '30px'" visibleoffset="500" v-if="!hideScrollToTop">
								<vs-button icon-pack="feather" icon="icon-arrow-up" class="shadow-lg btn-back-to-top" />
							</back-to-top>

							<transition :name="routerTransition" mode="out-in">
								<router-view @changeRouteTitle="changeRouteTitle" @setAppClasses="(classesStr) => $emit('setAppClasses', classesStr)" />
							</transition>
						</div>
					</div>
				</div>
			</div>
			<the-footer />
		</div>
	</div>
	<div v-else>
		Hãy tải app để có trải nghiệm tốt nhất
	</div>
</template>

<script>
import BackToTop from "vue-backtotop";
import HNavMenu from "@/layouts/components/horizontal-nav-menu/HorizontalNavMenu.vue";
import navMenuItems from "@/layouts/components/vertical-nav-menu/navMenuItems.js";
import TheCustomizer from "@/layouts/components/customizer/TheCustomizer.vue";
import TheNavbarHorizontal from "@/layouts/components/navbar/TheNavbarHorizontal.vue";
import TheNavbarVerticalCustom from "@/layouts/components/navbar/TheNavbarVerticalCustom.vue";
import TheFooter from "@/layouts/components/TheFooter.vue";
import themeConfig from "@/../themeConfig.js";
import VNavMenu from "@/layouts/components/vertical-nav-menu/VerticalNavMenu.vue";

const VxTour = () => import("@/components/VxTour.vue");

export default {
	components: {
		BackToTop,
		HNavMenu,
		TheCustomizer,
		TheFooter,
		TheNavbarHorizontal,
		TheNavbarVerticalCustom,
		VNavMenu,
		VxTour,
	},
	data() {
		return {
			isMobile: false,
			disableCustomizer: themeConfig.disableCustomizer,
			disableThemeTour: themeConfig.disableThemeTour,
			dynamicWatchers: {},
			footerType: themeConfig.footerType || "static",
			hideScrollToTop: themeConfig.hideScrollToTop,
			isNavbarDark: false,
			navbarColor: themeConfig.navbarColor || "#fff",
			navbarType: themeConfig.navbarType || "floating",
			navMenuItems: navMenuItems,
			routerTransition: themeConfig.routerTransition || "none",
			routeTitle: this.$route.meta.pageTitle,
			steps: [
				{
					target: "#btnVNavMenuMinToggler",
					content: "Toggle Collapse Sidebar.",
				},
				{
					target: ".vx-navbar__starred-pages",
					content: "Create your own bookmarks. You can also re-arrange them using drag & drop.",
				},
				{
					target: ".i18n-locale",
					content: "You can change language from here.",
				},
				{
					target: ".navbar-fuzzy-search",
					content: "Try fuzzy search to visit pages in flash.",
				},
				{
					target: ".customizer-btn",
					content: "Customize template based on your preference",
					params: {
						placement: "left",
					},
				},
				{
					target: ".vs-button.buy-now",
					content: "Buy this awesomeness at affordable price!",
					params: {
						placement: "top",
					},
				},
			],
		};
	},
	watch: {
		$route() {
			this.routeTitle = this.$route.meta.pageTitle;
		},
		isThemeDark(val) {
			const color = this.navbarColor == "#fff" && val ? "#10163a" : "#fff";
			this.updateNavbarColor(color);
		},
		"$store.state.mainLayoutType"(val) {
			this.setNavMenuVisibility(val);
			this.disableThemeTour = true;
		},
	},
	computed: {
		bodyOverlay() {
			return this.$store.state.bodyOverlay;
		},
		contentAreaClass() {
			if (this.mainLayoutType === "vertical") {
				if (this.verticalNavMenuWidth == "default") return "content-area-reduced";
				else if (this.verticalNavMenuWidth == "reduced") return "content-area-lg";
				else return "content-area-full";
			}
			// else if(this.mainLayoutType === "boxed") return "content-area-reduced"
			else return "content-area-full";
		},
		footerClasses() {
			return {
				"footer-hidden": this.footerType == "hidden",
				"footer-sticky": this.footerType == "sticky",
				"footer-static": this.footerType == "static",
			};
		},
		isAppPage() {
			return this.$route.meta.no_scroll;
		},
		isThemeDark() {
			return this.$store.state.theme == "dark";
		},
		layoutTypeClass() {
			return `main-${this.mainLayoutType}`;
		},
		mainLayoutType() {
			return this.$store.state.mainLayoutType;
		},
		navbarClasses() {
			return {
				"navbar-hidden": this.navbarType == "hidden",
				"navbar-sticky": this.navbarType == "sticky",
				"navbar-static": this.navbarType == "static",
				"navbar-floating": this.navbarType == "floating",
			};
		},
		verticalNavMenuWidth() {
			return this.$store.state.verticalNavMenuWidth;
		},
		windowWidth() {
			return this.$store.state.windowWidth;
		},
	},
	methods: {
		changeRouteTitle(title) {
			this.routeTitle = title;
		},
		updateNavbar(val) {
			if (val == "static") this.updateNavbarColor(this.isThemeDark ? "#10163a" : "#fff");
			this.navbarType = val;
		},
		updateNavbarColor(val) {
			this.navbarColor = val;
			if (val == "#fff") this.isNavbarDark = false;
			else this.isNavbarDark = true;
		},
		updateFooter(val) {
			this.footerType = val;
		},
		updateRouterTransition(val) {
			this.routerTransition = val;
		},
		setNavMenuVisibility(layoutType) {
			if ((layoutType === "horizontal" && this.windowWidth >= 1200) || (layoutType === "vertical" && this.windowWidth < 1200)) {
				this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", false);
				this.$store.dispatch("updateVerticalNavMenuWidth", "no-nav-menu");
			} else {
				this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", true);
			}
		},
		toggleHideScrollToTop(val) {
			this.hideScrollToTop = val;
		},
	},
	created() {
		const color = this.navbarColor == "#fff" && this.isThemeDark ? "#10163a" : this.navbarColor;
		this.updateNavbarColor(color);
		this.setNavMenuVisibility(this.$store.state.mainLayoutType);

		// Dynamic Watchers for tour
		// Reason: Once tour is disabled it is not required to enable it.
		// So, watcher is required for just disabling it.
		this.dynamicWatchers.windowWidth = this.$watch("$store.state.windowWidth", (val) => {
			if (val < 1200) {
				this.disableThemeTour = true;
				this.dynamicWatchers.windowWidth();
			}
		});

		this.dynamicWatchers.verticalNavMenuWidth = this.$watch("$store.state.verticalNavMenuWidth", () => {
			this.disableThemeTour = true;
			this.dynamicWatchers.verticalNavMenuWidth();
		});

		this.dynamicWatchers.rtl = this.$watch("$vs.rtl", () => {
			this.disableThemeTour = true;
			this.dynamicWatchers.rtl();
		});
		this.$store.dispatch("getProvince", {
			country_id: "86",
		});
	},
	beforeDestroy() {
		Object.keys(this.dynamicWatchers).map((i) => {
			this.dynamicWatchers[i]();
			delete this.dynamicWatchers[i];
		});
	},
	// mounted() {
	// 	if (window.innerWidth <= 800) {
	// 		this.isMobile = true;
	// 	}
	// }
};
</script>

<style>
 #style-1::-webkit-scrollbar-track
{
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    border-radius: 10px;
    background-color: #F5F5F5;
	display: block !important;
}

#style-1::-webkit-scrollbar
{
    width: 12px;
    background-color: #F5F5F5;
	display: block !important;
}

#style-1::-webkit-scrollbar-thumb
{
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
    background-color: #555;
}

::-webkit-scrollbar {
    display: none;
}


.el-date-picker {
	z-index: 29000 !important;
}
.vx-navbar-wrapper {
	height: 83px !important;
}
.router-view {
	padding-top: 0.5rem !important;
}
.custom-dialog {
	z-index: 22001 !important;
}
.custom-nested-dialog {
	z-index: 22002 !important;
}
@media screen and (max-width: 600px) {
	.custom-dialog .el-dialog {
		height: auto !important;
		overflow-y: auto !important;
	}
}
.v-nav-menu .vs-sidebar {
    z-index: 99999 !important;
}
</style>
